import { Fragment } from 'react';
import { Typography } from '@mui/material';
import { theme } from '@theguarantors/tg-package-material-ui';

import { type Renter } from '@/utils/types/renter.interface';

import { InviteLeaseDetailsSharedForm } from './invite-lease-details.shared-form';
import { useInviteLeaseDetailsController } from './hooks';
import type { InviteFlowMilestoneKey } from './types';

export type InviteLeaseDetailsDrawerFormContentProps = {
  onSuccess?: (renter: Renter) => void;
  onMilestoneReached?: (key: InviteFlowMilestoneKey) => void;
};

export function InviteLeaseDetailsDrawerFormContent({
  onSuccess,
  onMilestoneReached,
}: InviteLeaseDetailsDrawerFormContentProps) {
  const controller = useInviteLeaseDetailsController({ onSuccess });

  return (
    <Fragment>
      <Typography
        mb={3}
        letterSpacing={0}
        sx={{
          fontSize: '16px !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
            lineHeight: '22px',
          },
        }}
      >
        Please fill out your applicant's information below, and we will send them an invitation to
        apply using the email address provided.
      </Typography>
      <InviteLeaseDetailsSharedForm
        controller={controller}
        onMilestoneReached={onMilestoneReached}
      />
    </Fragment>
  );
}
